import { useState } from "react";
import { ChevronDown, X } from "lucide-react";
import { money } from "@/lib/api";

function Group({ title, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-neutral-100 py-5">
      <button onClick={() => setOpen(!open)} className="flex items-center justify-between w-full">
        <span className="over text-[0.65rem]">{title}</span>
        <ChevronDown size={15} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="mt-4 space-y-2.5">{children}</div>}
    </div>
  );
}

export default function Filters({ facets, creators, selected, onToggle, onPrice, onCreator, onReset, priceBounds }) {
  const isSel = (key, val) => (selected[key] || "").split(",").filter(Boolean).includes(val);
  return (
    <div data-testid="filters-panel">
      <div className="flex items-center justify-between pb-2">
        <span className="over text-xs">Filtres</span>
        <button onClick={onReset} data-testid="filter-reset" className="over text-[0.6rem] text-[#E0115F] inline-flex items-center gap-1">
          Réinitialiser <X size={12} />
        </button>
      </div>

      <Group title="Prix">
        <div className="flex items-center gap-2">
          <input type="number" placeholder={`${priceBounds[0]}`} defaultValue={selected.price_min || ""} onBlur={(e) => onPrice("price_min", e.target.value)}
            className="w-full border border-neutral-200 px-2 py-1.5 text-sm" data-testid="filter-price-min" />
          <span className="text-neutral-400">—</span>
          <input type="number" placeholder={`${priceBounds[1]}`} defaultValue={selected.price_max || ""} onBlur={(e) => onPrice("price_max", e.target.value)}
            className="w-full border border-neutral-200 px-2 py-1.5 text-sm" data-testid="filter-price-max" />
        </div>
        <p className="text-xs text-neutral-400">{money(priceBounds[0])} – {money(priceBounds[1])}</p>
      </Group>

      {Object.entries(facets || {}).map(([key, f]) =>
        f.values.length ? (
          <Group key={key} title={f.label}>
            {f.values.map((v) => (
              <label key={v.value} className="flex items-center gap-2.5 cursor-pointer group" data-testid={`filter-${key}-${v.value}`}>
                <span className={`w-4 h-4 border flex items-center justify-center ${isSel(key, v.value) ? "bg-[#0A0A0A] border-[#0A0A0A]" : "border-neutral-300"}`}>
                  {isSel(key, v.value) && <span className="w-1.5 h-1.5 bg-white" />}
                </span>
                <input type="checkbox" className="hidden" checked={isSel(key, v.value)} onChange={() => onToggle(key, v.value)} />
                <span className="text-sm text-neutral-700 group-hover:text-black flex-1">{v.value}</span>
                <span className="text-xs text-neutral-300">{v.count}</span>
              </label>
            ))}
          </Group>
        ) : null
      )}

      {creators?.length > 1 && (
        <Group title="Créateur">
          {creators.map((c) => (
            <button key={c.id} onClick={() => onCreator(c.id)} className="flex items-center gap-2.5 w-full text-left" data-testid={`filter-creator-${c.id}`}>
              <span className={`w-4 h-4 border flex items-center justify-center ${selected.creator === c.id ? "bg-[#0A0A0A] border-[#0A0A0A]" : "border-neutral-300"}`}>
                {selected.creator === c.id && <span className="w-1.5 h-1.5 bg-white" />}
              </span>
              <span className="text-sm text-neutral-700">{c.name}</span>
            </button>
          ))}
        </Group>
      )}
    </div>
  );
}
